import { render, staticRenderFns } from "./carousel-landing.vue?vue&type=template&id=72ae7ec7&scoped=true"
import script from "./carousel-landing.vue?vue&type=script&lang=js"
export * from "./carousel-landing.vue?vue&type=script&lang=js"
import style0 from "./carousel-landing.vue?vue&type=style&index=0&id=72ae7ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae7ec7",
  null
  
)

export default component.exports